import { b as u, Ye as g, tt as f, z as R, _ as k, Ze as r, u as $, bt as A } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { i as I } from "./query-DolxHPXs-B8EMIjjI.js";
import { E as N } from "./keys-C6v8knyZ-hIRx1LW_.js";
import { l as S } from "./orientations-CF7v1a0i-CpGOrffM.js";
import { e as B, y as D, r as x, a as P } from "./lifecycle-decorators-CUsT9aHq-Dtp3uB6c.js";
import { A as T, N as z } from "./query-assigned-K46zQIzj-dGW7AjV_.js";
import { r as b } from "./utils-BSj5iT7c-dU4w2_Zv.js";
var p = /* @__PURE__ */ ((t) => (t.CLICK = "click", t.HOVER = "hover", t.MANUAL = "manual", t))(p || {}), h = /* @__PURE__ */ ((t) => (t.START = "start", t.CENTER = "center", t.END = "end", t))(h || {}), j = /* @__PURE__ */ ((t) => (t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t))(j || {}), o = /* @__PURE__ */ ((t) => (t.BlockStart = "block-start", t.InlineStart = "inline-start", t.BlockEnd = "block-end", t.InlineEnd = "inline-end", t))(o || {});
function K(t, l) {
  return t.has(l) && typeof t.get(l) < "u";
}
var W = Object.defineProperty, H = Object.getOwnPropertyDescriptor, s = (t, l, i, a) => {
  for (var c = a > 1 ? void 0 : a ? H(l, i) : l, e = t.length - 1, n; e >= 0; e--)
    (n = t[e]) && (c = (a ? n(l, i, c) : n(c)) || c);
  return a && c && W(l, i, c), c;
};
const _ = (t) => function(l) {
  let i = class extends l {
    constructor() {
      super(...arguments), this.orientation = S.VERTICAL, this.trigger = p.HOVER, this.isOpen = !1, this.content = "", this.alignment = h.CENTER, this.direction = o.InlineStart, this.topOffset = 0, this.leftOffset = 0, this.RTL = !1, this.marginAdjust = 0, this.targetSelectorString = ".overlay-target", this.debouncedCalculateOffset = b(this.calculateOffset.bind(this), 100), this.toggleClick = (e) => {
        e && e.isTrusted && (this.isOpen ? this.close() : this.open());
      }, this.intersectionObserver = new IntersectionObserver(this.debouncedCalculateOffset, { threshold: 1 }), this.resizeObserver = new ResizeObserver(this.debouncedCalculateOffset), this.open = t && !t.disableDebounceOpen ? b(async () => {
        this.calculateOffset(), this.isOpen = !0, this.showTooltip(), await this.updateComplete, this.emitOpen();
      }, 100) : async () => {
        this.calculateOffset(), this.isOpen = !0, this.showTooltip(), await this.updateComplete, this.emitOpen();
      }, this.handleKeydown = (e) => {
        e.isTrusted && this.isOpen && (super.handleKeydown(), this.closeOnEscape(e));
      }, this.handleExternalClick = (e) => {
        e.isTrusted && !e.composedPath().includes(this.overlayEl) && this.isOpen && this.close();
      };
    }
    get targetSelector() {
      return this.targetSelectorString;
    }
    set targetSelector(e) {
      this.targetSelectorString = e;
    }
    get viewportRect() {
      var e;
      return (e = this.viewportRectObj) != null ? e : document.documentElement.getBoundingClientRect();
    }
    set viewportRect(e) {
      this.viewportRectObj = e;
    }
    set targetRect(e) {
      this.targetRectObj = e;
    }
    get scrollListeningContainer() {
      var e;
      return (e = this.scrollListeningContainerObj) != null ? e : window;
    }
    set scrollListeningContainer(e) {
      this.scrollListeningContainerObj = e;
    }
    get overlaySelector() {
      return ".overlay-wrapper";
    }
    get overlayName() {
      return "overlay";
    }
    get externalClickNode() {
      return this.getRootNode();
    }
    static get overlayStyles() {
      return [];
    }
    /**
     * Calculates margin adjustment for when the overlay component is visible
     * @param marginToken token representing the margin of the overlay component
     * @param arrowSizeToken token representing the size of the arrow on the overlay
     */
    computeMarginAdjustment(e, n) {
      this.marginAdjust = parseInt(e, 10) + parseInt(n, 10) / 2;
    }
    /**
     * Evaluate Alignment and Direction based on the Target and Overlay DOMRect.
     * @param target DOMRect of the target element
     * @param overlay DOMRect of the overlay element
     */
    computeDirection(e, n) {
      this.orientation === S.VERTICAL ? (e.y < this.viewportRect.height / 4 ? this.direction = o.BlockStart : this.direction = o.BlockEnd, e.x < this.viewportRect.width / 4 ? this.alignment = h.START : e.x > this.viewportRect.width * 3 / 4 ? this.alignment = h.END : this.alignment = h.CENTER) : (this.alignment = h.CENTER, this.RTL ? this.viewportRect.width < e.x ? this.direction = o.InlineEnd : this.direction = o.InlineStart : e.x + e.width + n.width < this.viewportRect.width ? this.direction = o.InlineStart : this.direction = o.InlineEnd);
    }
    /**
     * @param overlayWidth Width of the Overlay element
     * @param targetWidth Width of the Target Element
     * @returns Based on Alignment, will return leftOffset as number.
     */
    calculateHorizontalOffset(e, n) {
      const d = n - e, v = e / 2 - this.marginAdjust;
      switch (this.alignment) {
        case h.START:
          return d / 2 + v;
        case h.CENTER:
          return d / 2;
        case h.END:
          return d / 2 - v;
        default:
          return 0;
      }
    }
    /**
     * Evaluate the Overlay Leftoffset and topOffset based on targetSelector and Overlay Selector.
     * @abstract
     */
    calculateOffset() {
      var e, n, d;
      const v = (e = this.shadowRoot) == null ? void 0 : e.querySelector(this.targetSelector), E = (n = this.shadowRoot) == null ? void 0 : n.querySelector(this.overlaySelector);
      if (E && (v || this.targetRectObj)) {
        const w = (d = this.targetRectObj) != null ? d : v == null ? void 0 : v.getBoundingClientRect(), L = E.getBoundingClientRect();
        this.computeDirection(w, L);
        const { height: y, width: m } = w, { height: O, width: C } = L;
        switch (this.topOffset = 0, this.leftOffset = m, this.direction) {
          case o.BlockEnd:
            this.topOffset = -1 * (y + O), this.leftOffset = this.calculateHorizontalOffset(C, m);
            break;
          case o.BlockStart:
            this.leftOffset = this.calculateHorizontalOffset(C, m);
            break;
          case o.InlineEnd:
            this.leftOffset = -1 * C, this.topOffset = -1 * (O + (y - O) / 2);
            break;
          case o.InlineStart:
            this.topOffset = -1 * (O + (y - O) / 2);
            break;
        }
      }
    }
    /**
     * Enables overlay surface to reposition and reorient based on:
     * 1. When overlayWrapper is intersecting with viewport border
     * 2. When document body is resized
     * 3. When user scrolls
     */
    engageDynamicOverlayPositioning() {
      this.intersectionObserver.observe(this.overlayWrapper), this.resizeObserver.observe(document.body), this.scrollListeningContainer.addEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Disengages dynamic overlay positioning by unobserving by:
     * 1. Unobserving overlayWrapper intersections with viewport
     * 2. Unobserving resize of the document body
     * 3. Removing scroll event listener from scrollListeningContainer
     */
    disengageDynamicOverlayPositioning() {
      this.intersectionObserver.unobserve(this.overlayWrapper), this.resizeObserver.unobserve(document.body), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Destroys dynamic overlay positioning by:
     * 1. Disconnecting intersection observer
     * 2. Disconnecting resize observer
     * 3. Removing scroll event listener from scrollListeningContainer
     * This method is intended for use when disconnecting component.
     */
    destroyDynamicOverlayPositioning() {
      this.intersectionObserver.disconnect(), this.resizeObserver.disconnect(), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Adds event listener to the document to close the overlay when clicked outside
     */
    showTooltip() {
      setTimeout(() => {
        this.trigger === p.CLICK && document.addEventListener(f.CLICK, this.handleExternalClick);
      }, 100);
    }
    /**
     * Makes the overlay hidden.
     */
    close() {
      this.isOpen = !1, this.trigger === p.CLICK && document.removeEventListener(f.CLICK, this.handleExternalClick);
    }
    /** Closes the popover when the key pressed is the escape key. */
    closeOnEscape(e) {
      e.key === N.ESCAPE && this.close();
    }
    /**
     * @event {BeaconEvents} beacon-events-close - emits when the overlay is closed with the close() method.
     */
    emitClose() {
      R(this, k.CLOSE, !!this.onBeaconClose && this.onBeaconClose());
    }
    /**
     * @event {BeaconEvents} beacon-events-open - emits when the overlay is closed with the open() method.
     */
    emitOpen() {
      R(this, k.OPEN, !!this.onBeaconOpen && this.onBeaconOpen());
    }
    /**
     * Lit lifecycle hook to handle changing of properties
     */
    updated(e) {
      K(e, "isOpen") && (this.isOpen ? (this.open(), this.emitOpen()) : (this.close(), this.emitClose()));
    }
    overlayPrerender() {
      this.isOpen && this.open(), this.externalClickNode.addEventListener(f.KEYDOWN, this.handleKeydown);
    }
    overlayPostrender() {
      this.calculateOffset();
    }
    overlayDestroy() {
      this.destroyDynamicOverlayPositioning(), this.externalClickNode.removeEventListener(f.KEYDOWN, this.handleKeydown), this.externalClickNode.removeEventListener(f.CLICK, this.handleExternalClick);
    }
    /**
     * Render template: slotted element
     */
    renderSlot() {
      return this.trigger === p.HOVER ? r`<slot @mouseover=${this.open} @mouseout=${this.close}></slot>` : this.trigger === p.CLICK ? r`<slot @click=${this.toggleClick}></slot>` : r`<slot></slot>`;
    }
    /**
     * Render template: overlay content
     */
    renderOverlayContent() {
      return r`<p>${this.content}</p>`;
    }
    /**
     * Render template: overlay content skeleton
     */
    renderContentWrapper() {
      return r`<div class="tooltip-content" aria-live="${this.isOpen ? "polite" : "off"}">${this.renderOverlayContent()}</div>`;
    }
    /**
     * Render template: arrow
     * @todo align the arrow implementation with the navigation popover arrow
     */
    renderArrow() {
      return r`<span class="overlay-arrow ${this.alignment}" aria-hidden="true"></span>`;
    }
    /**
     * Render template: entire overlay skeleton
     */
    renderOverlayWrapper() {
      return this.style.setProperty("--left-offset", `${this.leftOffset}px`), this.style.setProperty("--top-offset", `${this.topOffset}px`), r`<div
          id="${this.overlayName}"
          role="tooltip"
          aria-hidden="${this.isOpen ? "false" : "true"}"
          class="overlay-wrapper ${this.direction}"
        >
          ${this.renderArrow()} ${this.renderContentWrapper()}
        </div>`;
    }
    /**
     * Render template: overlay and target
     */
    render() {
      return r`${this.trigger === p.MANUAL ? $ : r`<div class="overlay-target" aria-describedBy="${this.overlayName}">${this.renderSlot()}</div>`}
        ${this.renderOverlayWrapper()}`;
    }
  };
  s([
    u()
  ], i.prototype, "orientation", 2), s([
    u()
  ], i.prototype, "trigger", 2), s([
    u({ type: Boolean, reflect: !0, attribute: "is-open" })
  ], i.prototype, "isOpen", 2), s([
    u()
  ], i.prototype, "content", 2), s([
    u({ type: Function })
  ], i.prototype, "onBeaconClose", 2), s([
    u({ type: Function })
  ], i.prototype, "onBeaconOpen", 2), s([
    g()
  ], i.prototype, "alignment", 2), s([
    g()
  ], i.prototype, "direction", 2), s([
    g()
  ], i.prototype, "topOffset", 2), s([
    g()
  ], i.prototype, "leftOffset", 2), s([
    g()
  ], i.prototype, "RTL", 2), s([
    T("div#tooltip")
  ], i.prototype, "overlayEl", 2), s([
    I(".overlay-wrapper")
  ], i.prototype, "overlayWrapper", 2), s([
    B
  ], i.prototype, "overlayPrerender", 1), s([
    D
  ], i.prototype, "overlayPostrender", 1), s([
    x
  ], i.prototype, "overlayDestroy", 1), i = s([
    P("Overlay")
  ], i);
  class a extends i {
    constructor() {
      super(...arguments), this.open = t && !t.disableDebounceOpen ? b(async () => {
        this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.showTooltip();
      }, 100) : async () => {
        this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.showTooltip();
      };
    }
    /**
     * Handle close and return focus to active element.
     * Also removes listener and observer logic when overlay closed for better performance.
     */
    close() {
      super.close(), this.disengageDynamicOverlayPositioning(), this.focusOnActiveElement();
    }
    /**
     * Handle dark mode theming in action zone
     */
    setActionZoneDarkMode() {
      this.slottedActionzone && this.slottedActionzone.length && this.slottedActionzone.forEach((e) => {
        e.classList.contains("beacon-on-dark") || e.classList.add("beacon-on-dark");
      });
    }
    /**
     * Focuses on the previously active element
     */
    focusOnActiveElement() {
      var e;
      (e = this.activeElement) == null || e.focus();
    }
    /**
     * Render template: close icon button
     */
    renderCloseButton() {
      return A`<${this.getScopedTag("beacon-icon-button")}
                variant="tertiary"
                label="Close Button"
                class="beacon-popover-close-button beacon-on-dark"
                @beacon-event-click="${this.close}"
                >
                <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"/>
                </svg>
                </${this.getScopedTag("beacon-icon-button")}>
                `;
    }
    /**
     * Render template: adjusts content wrapper
     */
    renderContentWrapper() {
      return r`<div class="beacon-popover-surface">
          ${this.renderCloseButton()}
          <div class="beacon-popover-zones-wrapper" aria-live="${this.isOpen ? "polite" : "off"}">${this.renderOverlayContent()}</div>
        </div>`;
    }
    /**
     * Render template: slot with only click event
     */
    renderSlot() {
      return r`<slot @click=${this.toggleClick}></slot>`;
    }
  }
  return s([
    T("div#overlay")
  ], a.prototype, "overlayEl", 2), s([
    g()
  ], a.prototype, "activeElement", 2), s([
    z({ flatten: !0, slot: "actionzone" })
  ], a.prototype, "slottedActionzone", 2), t && t.interactive ? a : i;
};
export {
  j as K,
  _ as U,
  p as h,
  K as j,
  h as l,
  o as n
};
